import ProfileImage from "./ProfileImage";
import {
  useAzureStorage,
  StorageEndpoint,
} from "../hooks/useAzureStorage";

import "./ProfileImage.css";

export interface ContactProfile {
  contactId: string;
}

interface ProfileImageProps {
  profile: ContactProfile;
  onSelect?: (profile: ContactProfile) => void;
}

const ContactProfileImage: React.FC<ProfileImageProps> = ({
  profile,
}) => {
  const imageFileName = `${profile.contactId}.jpg`;

  const { storageDetail } = useAzureStorage(
    StorageEndpoint.profile,
    imageFileName,
    true
  );

  return <ProfileImage profile={{ url: storageDetail?.Url }} />;
};

export default ContactProfileImage;
